<div class="cp-ah__container">
  <div></div>
  <div class="cp-ah__right">
    <if(input.name)>
      <ebay-menu-button
        text=input.name
        borderless
        priority="none"
        on-select("onMenuSelect")
      >
        <@icon><ebay-profile-16-icon/></@icon>
        <@item>Sign out</@item>
      </ebay-menu-button>
    </if>
    <theme-switch />
  </div>
</div>

style {
  .cp-ah__container {
    display: flex;
    justify-content: space-between;
    padding: 1rem 2rem;
  }
  .cp-ah__right {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .cp-ah__right button {
    cursor: pointer;
  }

  .cp-ah__right .menu-button__item[role="menuitem"] {
    cursor: pointer;
    margin: 0;
  }
}
